import { createContext, useContext, useState, useEffect } from "react";
import landingService from "../landing.service";
import { Eventbus } from "../../../utils";
import { events } from "../../../utils/constants";
import logger from "../../../utils/logger";

const LandingServiceContext = createContext();

export function LandingServiceProvider({ children, isAdmin = false }) {
  const [status, setStatus] = useState({});
  const [isStatusLoading, setIsStatusLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load data function
  const loadData = async () => {
    setIsStatusLoading(true);
    setError(null);
    try {
      await landingService.loadData(isAdmin);
      // Data will be updated via event bus
    } catch (err) {
      setError(err.message || "Failed to load data");
      setIsStatusLoading(false);
      logger.error("Error loading landing data:", err);
    }
  };

  // Refresh data function
  const refreshData = () => {
    loadData();
  };

  function setStatusViaEvent(statusData) {
    setStatus(statusData);
    setIsStatusLoading(false);
  }

  useEffect(() => {
    // Set up event listeners
    Eventbus.on(events.STATS.STATUS_LOADED, setStatusViaEvent);
    Eventbus.on(events.STATS.STATUS_UPDATED, setStatusViaEvent);

    // Load initial data
    loadData();

    return () => {
      // Clean up event listeners
      Eventbus.off(setStatusViaEvent);
    };
  }, []);

  const contextValue = {
    // State
    status,
    isStatusLoading,
    error,

    // Actions
    loadData,
    refreshData,
    setStatus,
    setError,
  };

  return <LandingServiceContext.Provider value={contextValue}>{children}</LandingServiceContext.Provider>;
}

export const useLandingService = () => {
  const context = useContext(LandingServiceContext);
  if (!context) {
    throw new Error("useLandingService must be used within a LandingServiceProvider");
  }
  return context;
};

export default LandingServiceContext;
